export default __webpack_public_path__ + "static/media/Cuisse of the Death Master.3bfb01d1.jpg";